export function getRandomNumber ({ max, min = 0 }: { max: number; min?: number }) {
  return Math.random() * (max - min) + min;
}
